import ReactGA from 'react-ga4'

const reactGA = (
  typeof (ReactGA as { initialize?: unknown })?.initialize === 'function'
    ? ReactGA
    : (ReactGA as unknown as { default: typeof ReactGA }).default
) as typeof ReactGA

export const initAnalytics = (analyticsCode?: string): void => {
  if (analyticsCode) {
    reactGA.initialize(analyticsCode)
  }
}
